﻿import intlTelInput from "../../vendor/intlTelInput/intlTelInput.js";

(function ($, document) {

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    function SetupInternationalPlugin() {
        document
            .querySelectorAll(".international-phone")
            .forEach(function (input, i) {
                var hdnCountryCode = document.querySelector(input.dataset.countryCode);

                var settings = {
                    initialCountry: "auto",
                    preferredCountries: ['gb'],
                    separateDialCode: true,
                    autoPlaceholder: "off",
                    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/15.0.2/js/utils.js',
                    geoIpLookup: function (success, failure) {
                        $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
                            var countryCode = (resp && resp.country) ? resp.country : "gb";
                            success(countryCode);
                        });
                    }
                };

                if (hdnCountryCode.value) {
                    settings.initialCountry = hdnCountryCode.value;
                    settings.geoIpLookup = null;
                    if (settings.initialCountry.toUpperCase() !== "GB") {
                        settings.preferredCountries = ['gb', settings.initialCountry];
                    }
                } else {
                    hdnCountryCode.value = 'gb';
                }

                var iti = intlTelInput(input, settings);

                input.addEventListener("countrychange", function () {
                    var country = iti.getSelectedCountryData();
                    hdnCountryCode.value = country.iso2;
                });
            })
        ;
    }

    function SetupLegacyDiallingCode() {
        if (!$('.international-phone').length) {
            return;
        }
        $.get("/api/countries/legacy-dial-codes-html", function (data) {
            $('.international-phone')
                .wrap('<div class="legacy-international-phone"></div>')
                .before('<select class="countries">' + data.html + '</select>')
            ;
        });

        $(document).on('change', '.countries', function (e) {
            e.preventDefault();
            var $hdnCountryCode = $($(this).siblings('.international-phone').data('country-code'));
            $hdnCountryCode.val($(this).find(':selected').val());
        });
    }

    function SetupAccountPhone() {
        if (!$('[data-international-phone-codes]').length) {
            return;
        }

        $.get("/api/countries/legacy-dial-codes-html", function (data) {
            $('[data-international-phone-codes]')
                .html(data.html);
        });
    }

    $(document).ready(function () {
        try {
            SetupInternationalPlugin();
        }
        catch (err) {
            console.log(err);
            SetupLegacyDiallingCode();
        }
        SetupAccountPhone();
    });
})(jQuery, document);